<template>
  <section class="ml-0 position-relative">
    <div class="container mt-8 mt-sm-2">
      <div class="row py-lg-5">
        <div class="col-xl-5 col-lg-6 mb-5 position-relative">
          <img class="img border-radius-md  w-100 position-relative z-index-2 mt--3 "
            src="../assets/img/Smartfolio-logo.jpg" loading="lazy" alt="card image" />
        </div>
        <div class="col-xl-7 col-lg-6 z-index-2 position-relative pl-lg-9 pr-md-0 mt-lg--4 my-md-auto mt-sm-4">
          <h1 class=" ms-lg-9 display-1">Smartfolio</h1>
          <p class=" text-justify ms-lg-9 large-text">
            Smartfolio is an intelligent portfolio management system designed to simplify investing. "Firefly" and its
            watchlists helps you to track market trends and opportunities. The system detects triggers in real time
            based on your chosen Portfolios. Once a trigger is identified, Smartfolio dynamically allocates stocks
            within your portfolio to optimize performance. With Smartfolio, investing becomes smarter, easier, and more
            efficient.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<style></style>